export const secondsToMMSS = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, "0")}:${secs
    .toString()
    .padStart(2, "0")}`;
};

export const mmssToSeconds = (mmss) => {
  const [minStr, secStr] = mmss.split(":");
  const minutes = parseInt(minStr || "0", 10);
  const seconds = parseInt(secStr || "0", 10);
  return minutes * 60 + seconds;
};

/**
 * Convert UTC time (HH:mm format) to ET time
 * @param {string} utcTime - Time in HH:mm format (e.g., "23:00")
 * @returns {string} Formatted ET time (e.g., "06:00 PM")
 */
export const convertUTCtoET = (utcTime) => {
  if (!utcTime || !utcTime.includes(':')) return '';

  const [hours, minutes] = utcTime.split(':').map(Number);
  const utcDate = new Date();
  utcDate.setUTCHours(hours, minutes, 0, 0);

  // Convert to ET (America/New_York)
  const etString = utcDate.toLocaleTimeString('en-US', {
    timeZone: 'America/New_York',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });

  return etString;
};
